import uuid from 'uuid/v1';
import superagent from 'superagent';
import { wapClients, notificationMessage } from './wapData';

const { phone } = require('phone');

export function getNotificationMessage() {
  return notificationMessage;
}

export function isEmpty(value) {
  if (value === undefined || value === '') {
    return true;
  }
  return false;
}

export function getUUID() {
  try {
    return uuid();
  } catch (Error) {
    return '';
  }
}

export async function getPublicIp() {
  return '127.0.0.1';
}

export function getWAPBusinessUnits() {
  const wapBusinessUnits = [];
  wapClients.forEach(client => wapBusinessUnits.push({ key: client.vendor, value: client.vendor, text: client.description }));
  return wapBusinessUnits;
}

export function getWAPBusinessUnit(props) {
  try {
    return props.auth._oktaAuth.tokenManager.get('idToken').claims.businessUnit.toUpperCase();
  } catch (Error) {
    return '';
  }
}

export function getAltAccountNumber(props, id) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return '';
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return '';
  }
  //
  if (clientData.altAccountNumberLogic === 'LOGIC-1') {
    return String(`${id.substring(0, id.length - 1)}`).padStart(9, '0');
  } else {
    return '';
  }
}

export function getCustomerSupportNumber(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return '';
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return '';
  }
  //
  return clientData.customerSupportNumber;
}

export function getManualName(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return '/WAP_User_Manual.pdf';
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return '/WAP_User_Manual.pdf';
  }
  //
  return (clientData.manualName === undefined ? '/WAP_User_Manual.pdf' : `/${clientData.manualName}`);
}

export function isMultipleSearchAllowed(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return clientData.allowMultipleAccountsSearch;
}

export function hasAccessLevelUpdate(props) {
  let retVal = false;
  ['WAP-FULL', 'WAP-UPDATE', 'WAP-FULL-NOAUTORENEW'].forEach((obj) => {
    if (props.auth._oktaAuth.tokenManager.get('idToken').claims.groups.includes(obj)) {
      retVal = true;
    }
  });
  return retVal;
}

export function isCCPaymentsAllowed(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return (clientData.allowCCPayments !== undefined ? clientData.allowCCPayments : false);
}

export function isECheckPaymentsAllowed(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return (clientData.allowECheckPayments !== undefined ? clientData.allowECheckPayments : false);
}

export function isHideNRTAForEnroll(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return clientData.hideNRTAForEnroll;
}

export function isHideBillMeLaterForEnroll(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return clientData.hideBillMeLaterForEnroll;
}

export function isHideContributionOptionForRenew(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return false;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return false;
  }
  //
  return clientData.hideContributionOptionForRenew;
}

export function isPCICompliantForPayments(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return true;
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return true;
  }
  //
  return clientData.pciCompliantForPayments;
}

export function isValidPhoneNumber(phoneNumber) {
  try {
    if (!isEmpty(phoneNumber) && (phoneNumber.length !== 10 || phone(phoneNumber).isValid !== true)) {
      return 'Invalid Phone Number, ';
    }
    return '';
  } catch (Error) {
    return '';
  }
}

export function isValidEmail(emailAddress) {
  return emailAddress.toLowerCase().match(/^[^@]+@[^@.]+\.[^@]*\w\w$/);
}

export function isValidAllEmailAddress(primaryEmailAddress, spouseEmailAddress) {
  let retMsg = '';
  try {
    if (!isEmpty(primaryEmailAddress) && !isValidEmail(primaryEmailAddress)) {
      retMsg = 'Invalid Primary Email Address, ';
    }
    if (!isEmpty(spouseEmailAddress) && !isValidEmail(spouseEmailAddress)) {
      retMsg += 'Invalid Spouse/Partner Email Address, ';
    }
    if (!isEmpty(retMsg)) {
      return retMsg;
    }
    if (!isEmpty(primaryEmailAddress) && !isEmpty(spouseEmailAddress) && (primaryEmailAddress === spouseEmailAddress)) {
      return 'Primary and Spouse/Partner Email Addresses cannot be the same, ';
    }
    return '';
  } catch (Error) {
    return '';
  }
}

export function sortTableDates(a, b, order) {
  if (order === 'asc') {
    return Date.parse(a) - Date.parse(b);
  } else if (order === 'desc') {
    return Date.parse(b) - Date.parse(a);
  } else {
    return Date.parse(a) - Date.parse(b);
  }
}

export function handleLocalSearchInputStorage(operation, input, defaultValue) {
  let retVal = '';
  if (operation === 'get') {
    const memberSearchInputVal = JSON.parse(window.localStorage.getItem('memberSearchInput'));
    retVal = (memberSearchInputVal !== null ? memberSearchInputVal[input] : defaultValue);
  } else if (operation === 'add') {
    window.localStorage.setItem('memberSearchInput', JSON.stringify(input));
  } else if (operation === 'remove') {
    window.localStorage.removeItem('memberSearchInput');
  }
  return retVal;
}

export function getCampaignId(props) {
  const vendorBU = getWAPBusinessUnit(props);
  if (vendorBU === '') {
    return 'FGAUWAPD';
  }
  //
  const clientData = wapClients.find(e => e.vendor === vendorBU);
  if (clientData === undefined) {
    return 'FGAUWAPD';
  }
  //
  return (clientData.campaignId === undefined ? 'FGAUWAPD' : clientData.campaignId);
}

export async function getOfferDetails(campaignId) {
  let retVal = {};
  try {
    const response = await superagent.get(`${process.env.AAI_GETOFFERDETAILS_ENDPOINT}?CampaignId=${campaignId}`);
    const USTerms = [];
    const InternationalTerms = [];
    retVal = {
      dvmCheckbox: (response.body.offer.offerDescription.indexOf('dvm-checkbox') >= 0),
      USTerms: [],
    };
    response.body.offer.offerBundles[0].options.forEach((offer) => {
      if (offer.rateGroup === '1') {
        const termValue = parseInt(offer.termValue, 10);
        const years = parseInt(offer.term, 10) / 12;
        let addlTextValue = `($${(termValue / years).toFixed(2)}/yr)`;
        let autoRenewalText = '';
        if (offer.optionCategory === '36') {
          autoRenewalText = 'with Automatic Renewal';
          addlTextValue = `($${termValue} first year - Save ${100 - ((termValue / offer.ratePlans[0].subscriptionPrice) * 100)}%)`;
        }
        USTerms.push({
          id: `US${offer.optionId}`,
          label: `${years} ${(years === 1 ? 'Year' : 'Years')} for $${offer.termValue} ${autoRenewalText}`,
          value: termValue,
          addlText: addlTextValue,
          optionCategory: offer.optionCategory,
          minTermValue: offer.minTermValue,
          mp2Information: {
            bundleCatCd: response.body.bundles[0].bundleCatCd,
            bundleId: response.body.bundles[0].bundleId,
            offerId: response.body.offer.offerCampaigns[0].offerId,
            optionId: offer.optionId,
          },
          autoRenew: (offer.optionCategory === '36'),
          length: years,
        });
      } else if (offer.rateGroup === '2') {
        const termValue = parseInt(offer.termValue, 10);
        const years = parseInt(offer.term, 10) / 12;
        InternationalTerms.push({
          id: `CAN${offer.optionId}`,
          label: `Canada, ${years} ${(years === 1 ? 'Year' : 'Years')} for $${offer.termValue}`,
          value: termValue,
          optionCategory: offer.optionCategory,
          minTermValue: offer.minTermValue,
          mp2Information: {
            bundleCatCd: response.body.bundles[0].bundleCatCd,
            bundleId: response.body.bundles[0].bundleId,
            offerId: response.body.offer.offerCampaigns[0].offerId,
            optionId: offer.optionId,
          },
          autoRenew: (offer.optionCategory === '36'),
          length: years,
        });
        InternationalTerms.push({
          id: `MEX${offer.optionId}`,
          label: `Mexico, ${years} ${(years === 1 ? 'Year' : 'Years')} for $${offer.termValue}`,
          value: termValue,
          optionCategory: offer.optionCategory,
          minTermValue: offer.minTermValue,
          mp2Information: {
            bundleCatCd: response.body.bundles[0].bundleCatCd,
            bundleId: response.body.bundles[0].bundleId,
            offerId: response.body.offer.offerCampaigns[0].offerId,
            optionId: offer.optionId,
          },
          autoRenew: (offer.optionCategory === '36'),
          length: years,
        });
      } else if (offer.rateGroup === '3') {
        const termValue = parseInt(offer.termValue, 10);
        const years = parseInt(offer.term, 10) / 12;
        InternationalTerms.push({
          id: `OTH${offer.optionId}`,
          label: `Other Countries, ${years} ${(years === 1 ? 'Year' : 'Years')} for $${offer.termValue}`,
          value: termValue,
          optionCategory: offer.optionCategory,
          minTermValue: offer.minTermValue,
          mp2Information: {
            bundleCatCd: response.body.bundles[0].bundleCatCd,
            bundleId: response.body.bundles[0].bundleId,
            offerId: response.body.offer.offerCampaigns[0].offerId,
            optionId: offer.optionId,
          },
          autoRenew: (offer.optionCategory === '36'),
          length: years,
        });
      }
    });
    retVal.USTerms = USTerms.sort((a, b) => a.length - b.length);
    retVal.InternationalTerms = InternationalTerms;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
  }
  return retVal;
}



// WEBPACK FOOTER //
// ./src/app/containers/Utils/index.js